import Vue from 'vue'
import VueRouter from 'vue-router'
import app from "../main";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Main',
        component: () => import("../views/Main")
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('../views/Home')
    },
    {
        path: "/logIn",
        name: "LogIn",
        component: () => import("../views/LogIn")
    },
    {
        path: "/signUp",
        name: "SignUp",

        component: () => import("../views/SignUp")
    },
    {
        path: "/passwordRecovery",
        name: "PasswordRecovery",
        component: () => import("../views/PasswordRecovery")
    },
    {
        path: "/freeJoin",
        name: "FreeJoin",
        component: () => import("../views/FreeJoin")
    },
    {
        path: "/joinMeeting",
        name: "JoinMeeting",
        component: () => import("../views/JoinMeeting")
    }
]

const router = new VueRouter({
    routes
})

router.beforeEach(async (to, from, next) => {
    const publicPages = ["Main", "LogIn", "SignUp", "PasswordRecovery", "FreeJoin"];
    if (!publicPages.includes(to.name) && (typeof app === "undefined" || !app.$store.getters.userInfo)) {
        next("/");
    } else
        next();
})

export default router
